import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Eye } from 'lucide-react';

import { ActionButton } from '@/shared/ui/action-button';
import { ShowDispositionDialog } from '@/features/show-disposition';

interface ShowDispositionButtonProps {
  consignmentId: string;
}

/**
 * Header counterpart of the `show-disposition` row action in the consignments
 * table — same icon, same label, same dialog.
 */
export function ShowDispositionButton({ consignmentId }: ShowDispositionButtonProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <ActionButton intent="view" size="sm" className="grow sm:grow-0" onClick={() => setOpen(true)}>
        <Eye className="h-4 w-4 mr-2" />
        {t('cmrlist.showdisposition.label', 'Show Disposition')}
      </ActionButton>

      <ShowDispositionDialog open={open} onOpenChange={setOpen} consignmentId={consignmentId} />
    </>
  );
}
